import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App.jsx";
import reportWebVitals from "./reportWebVitals.js";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { store, persistor } from "./redux/store";
import { ErrorBoundary } from "react-error-boundary";
import Error from "./pages/Error/page.jsx";
import quarterOfYear from 'dayjs/plugin/quarterOfYear'
import dayjs from "dayjs";

dayjs.extend(quarterOfYear)
const root = ReactDOM.createRoot(document.getElementById("root"));

const Index = () => {
  return (
    <>
      {/* <React.StrictMode> */}
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <BrowserRouter>
            <ErrorBoundary FallbackComponent={Error}>
              <App />
            </ErrorBoundary>
          </BrowserRouter>
        </PersistGate>
      </Provider>
      {/* </React.StrictMode> */}
    </>
  );
};

root.render(<Index />);
reportWebVitals();
